var map = {
	"./en.js": [
		366,
		27
	],
	"./jp.js": [
		367,
		26
	],
	"./zh.js": [
		368,
		25
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 357;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/language lazy ^\.\/.*\.js$
// module id = 357
// module chunks = 221